export function isIos() {
  // @ts-expect-error window.MSStream is for IE mobile detection
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window?.MSStream
}
